import { BrowserModule } from '@angular/platform-browser';
import { NgModule ,APP_INITIALIZER} from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AppComponent } from './app.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RegistrationComponent } from './registration/registration.component';
import { BrowseObligorComponent } from './browse-obligor/browse-obligor.component';
import { CurrentissuesComponent } from './currentissues/currentissues.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { HeaderComponent } from './header/header.component';
import { SideMenuOverviewComponent } from './side-menu-overview/side-menu-overview.component';
import { SideMenuhistoryComponent } from './side-menuhistory/side-menuhistory.component';
import { AuditedFinancialStatementsComponent } from './audited-financial-statements/audited-financial-statements.component';
import { SidenuenQAComponent } from './sidenuen-qa/sidenuen-qa.component';
import { QComponent } from './q/q.component';
import { AnnualFinancialInformationComponent } from './Annualfinancial/annual-financial-information.component';
import { BudgetsComponent } from './Budgets/budgets.component';
import { InterimfinancialsComponent } from './Interim/interimfinancials.component';
import { FailuretoProvideComponent } from './Failure/failureto-provide.component';
import { OtherFinancialOperatingComponent } from './OtherFinancial/other-financial-operating.component';
import { OtherEventbasedDisclosuresComponent } from './OtherEvent/other-eventbased-disclosures.component';
import { RatingChangeComponent } from './RatingChange/rating-change.component';
import { UnscheduledComponent } from './Unscheduled/unscheduled.component';
import { BondCallsComponent } from './BondCalls/bond-calls.component';
import { IssuesNoLongerComponent } from './IssuesNoLonger/issues-no-longer.component';
import { AskAQuestionComponent } from './AskAQuestion/ask-aquestion.component';
import { DacheaderComponent } from './dacheader/dacheader.component';
import { DacfooterComponent } from './dacfooter/dacfooter.component';
import { DachomepageComponent } from './Dachomepage/dachomepage.component';
import { DmcaComponent } from './dmca/dmca.component';
import { DACForInvestorsComponent } from './DACForInvestors/dacfor-investors.component';
import { IssuersandObligorsComponent } from './IssuersandObligors/issuersand-obligors.component';
import { DacinsideheaderComponent } from './Dacinsideheader/dacinsideheader.component';
import { LegalInformationComponent } from './LegalInformation/legal-information.component';
import { AccessingwebcastsComponent } from './Accessingwebcasts/accessingwebcasts.component';
import { RegistrationserviceService } from './services/registrationservice.service';
import { HttpClientModule } from '@angular/common/http';
import { AboutusComponent } from './aboutus/aboutus.component';
import { TranslateService } from './translate.service';
import { TranslatePipe } from './translate.pipe';
import { PostIssuanceTaxComplianceComponent } from './PostIssuanceTaxCompliance/post-issuance-tax-compliance.component';
import { FooterComponent } from './footer/footer.component';
import { HelpComponent } from './help/help.component';
import { SitemapComponent } from './sitemap/sitemap.component';
import { AboutUsSecuritiesComponent } from './aboutUsSecurities/about-us-securities.component';
import { BrowseobligorService } from './services/browseobligor.service';
import { InvestorBrowseFilingTypesComponent } from './investor-browse-filing-types/investor-browse-filing-types.component';
import { InvestorBrowseBorrowingDocumentsComponent } from './investor-browse-borrowing-documents/investor-browse-borrowing-documents.component';

export function setupTranslateFactory(
  service: TranslateService): Function {
  return () => service.use('en');
}

@NgModule({
  declarations: [
    AppComponent,
    RegistrationComponent,
    BrowseObligorComponent,
    CurrentissuesComponent,
    SideMenuComponent,
    HeaderComponent,
    SideMenuOverviewComponent,
    SideMenuhistoryComponent,
    AuditedFinancialStatementsComponent,
    SidenuenQAComponent,
    QComponent,
    IssuesNoLongerComponent,
    AskAQuestionComponent,
    AnnualFinancialInformationComponent,
    BudgetsComponent,
    InterimfinancialsComponent,
    FailuretoProvideComponent,
    OtherFinancialOperatingComponent,
    OtherEventbasedDisclosuresComponent,
    RatingChangeComponent,
    UnscheduledComponent,
    BondCallsComponent,
    DacheaderComponent,
    DacfooterComponent,
    DachomepageComponent,
    DmcaComponent,
    DACForInvestorsComponent,
    IssuersandObligorsComponent,
    DacinsideheaderComponent,
    LegalInformationComponent,
    AccessingwebcastsComponent,
    AboutusComponent,    
    TranslatePipe,
    AboutUsSecuritiesComponent,
    PostIssuanceTaxComplianceComponent,
    FooterComponent,
    HelpComponent,
    SitemapComponent,
    InvestorBrowseFilingTypesComponent,
    InvestorBrowseBorrowingDocumentsComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    ReactiveFormsModule,
  ],
 
  providers: [
    RegistrationserviceService,
    BrowseobligorService,
    TranslateService,
    {
      provide: APP_INITIALIZER,
      useFactory: setupTranslateFactory,
      deps: [TranslateService],
      multi: true
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy } // use for application refreshable
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



